'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useObservedElement", {
    enumerable: true,
    get: function() {
        return useObservedElement;
    }
});
const _tabster = require("tabster");
const _useTabster = require("./useTabster");
const _useTabsterAttributes = require("./useTabsterAttributes");
function useObservedElement(name) {
    (0, _useTabster.useTabster)(_tabster.getObservedElement);
    return (0, _useTabsterAttributes.useTabsterAttributes)({
        observed: {
            names: Array.isArray(name) ? name : [
                name
            ]
        }
    });
}
